"use strict";

angular.module("customer")
.controller("AbstractStockCatalogEntryController", function(
    _this, $scope, $state, $stateParams, gettextCatalog, StocksService, CartItemService,
    StockProductDetailsModalService
) {
    $scope.isProductVariant = !!(
        _this.vendor.allow_product_variants
        && _this.catalogEntry.product.has_variants
        && $scope.catalogEntry.catalog_entry_variants.length
    );

    _this.isOutOfStock = function() {
        if (!$scope.isInventoryValidationRequired) {
            return false;
        }
        if ($scope.isProductVariant) {
            return false;
        }
        return _this.vendor.is_cart_vendor_exists && StocksService.isOutOfStock(_this.catalogEntry);
    };

    _this.isExpectedAvailabilityDateValid = function() {
        var expectedAvailabilityDate = _this.catalogEntry.expected_availability_date;
        return expectedAvailabilityDate && moment(expectedAvailabilityDate).isSameOrAfter(moment());
    };

    _this.showAlternativeProductButton = function() {
        var alternativeProductKeywords = _this.catalogEntry.alternative_product_keywords;
        if (!$scope.isCustomerInventoryAvailable || !alternativeProductKeywords) {
            return false;
        }
        return _this.isOutOfStock();
    };

    _this.searchSuggestedAlternative = function(event) {
        event.stopPropagation();
        $state.go("stocks", {
            search: _this.catalogEntry.alternative_product_keywords,
            vendorId: _this.vendor.id,
            lastCatalog: $stateParams.catalog,
            catalog: undefined
        });
    };

    _this.useVariableMeasure = function() {
        return (
            _this.vendor.enable_product_measure_management
            && _this.catalogEntry.product.is_variable_measure
            && CartItemService.isOnDeliverySelected(_this.vendor)
            && !$scope.isProductVariant
        );
    };

    _this.isCartItemQuantityValid = function() {
        if ($scope.isReturn) {
            return true;
        }

        var quantity = parseFloat(_this.catalogEntry.order_quantity);
        if (typeof _this.catalogEntry.discounted_order_quantity !== 'undefined') {
            quantity += parseFloat(_this.catalogEntry.discounted_order_quantity);
        }

        return CartItemService.isCartItemQuantityValid(
            _this.catalogEntry.quantity_min,
            _this.catalogEntry.quantity_max,
            quantity
        );
    };

    _this.isProductMultiplierValid = function() {
        if ($scope.isReturn) {
            return true;
        }

        var quantity = _this.catalogEntry.order_quantity;
        if ($scope.isCustomDiscount) {
            quantity = _this.catalogEntry.discounted_order_quantity;
        }
        return CartItemService.isProductMultiplierValid(_this.catalogEntry.packaging_quantity, quantity);
    };

    _this.isProductQuantityPatternValid = function() {
        var quantity = _this.catalogEntry.order_quantity;
        if ($scope.isCustomDiscount) {
            quantity = _this.catalogEntry.discounted_order_quantity;
        }
        return CartItemService.isProductQuantityPatternValid(quantity);
    };

    _this.isUnitOfMeasureQuantityPatternValid = function() {
        var quantity = _this.catalogEntry.order_quantity;
        var totalMeasure = _this.catalogEntry.total_measure;

        if ($scope.isCustomDiscount) {
            quantity = _this.catalogEntry.discounted_order_quantity;
            totalMeasure = _this.catalogEntry.discounted_total_measure;
        }
        if (!_this.useVariableMeasure() || parseFloat(quantity) === 0) {
            return true;
        }
        return CartItemService.isUnitOfMeasureQuantityPatternValid(totalMeasure);
    };

    _this.isOrderedValueMissingWithQuantityOfMeasure = function() {
        if ($scope.isCustomDiscount) {
            return CartItemService.isDiscountedValueMissingWithQuantityOfMeasure(_this.catalogEntry, _this.vendor);
        }
        return CartItemService.isOrderedValueMissingWithQuantityOfMeasure(_this.catalogEntry, _this.vendor);
    };

    _this.isProductInventoryQuantityValid = function() {
        if (!$scope.isInventoryValidationRequired) {
            return true;
        }
        if ($scope.isProductVariant) {
            return true;
        }

        var quantity = parseFloat(_this.catalogEntry.order_quantity);
        if (typeof _this.catalogEntry.discounted_order_quantity !== 'undefined') {
            quantity += parseFloat(_this.catalogEntry.discounted_order_quantity);
        }

        return (
            !_this.vendor.is_cart_vendor_exists
            || !_this.vendor.block_order_when_out_of_stock
            || CartItemService.isProductInventoryQuantityValid(
                _this.catalogEntry.inventory_quantity,
                quantity
            )
        );
    };

    _this.getOrderedValueMissingWithQuantityOfMeasureError = function() {
        return CartItemService.getOrderedValueMissingWithQuantityOfMeasureError()
    }

    _this.getProductQuantityPatternError = function() {
        return CartItemService.getProductQuantityPatternError();
    };

    _this.getQuantityMinMaxError = function() {
        return CartItemService.getQuantityMinMaxError(
            _this.catalogEntry.quantity_min,
            _this.catalogEntry.quantity_max
        );
    };

    _this.getUnitOfMeasureQuantityPatternError = function() {
        return CartItemService.getUnitOfMeasureQuantityPatternError();
    };

    _this.getProductMultiplierError = function() {
        return CartItemService.getProductMultiplierError(_this.catalogEntry.packaging_quantity);
    };

    _this.getProductInventoryQuantityError = function() {
        return CartItemService.getProductInventoryQuantityError(_this.catalogEntry.inventory_quantity);
    };

    _this.showProductDetails = function($index) {
        var params = {
            orderQuantity: _this.catalogEntry.order_quantity,
            totalMeasure: _this.catalogEntry.total_measure,
            discountedOrderQuantity: _this.catalogEntry.discounted_order_quantity,
            discountedTotalMeasure: _this.catalogEntry.discounted_total_measure,
            vendor: _this.vendor,
            index: $index,
            activeTab: $scope.activeTab,
            isVariableMeasure: _this.catalogEntry.product.is_variable_measure,
            isOrderTemplate: $scope.isOrderTemplate,
            deliveryRules: _this.vendor.delivery_rules,
            productAcquisitionMethod: _this.vendor.product_acquisition_method
        };
        StockProductDetailsModalService.showProductDetails(_this.catalogEntry, params)
        .then(function onSuccess(result) {
            _this.catalogEntry.preferred = result.preferred;
            _this.catalogEntry.product.inventory_product = result.inventoryProduct;

            if ($scope.isCustomDiscount) {
                _this.catalogEntry.discounted_order_quantity = result.discountedQuantity;
            }
            else {
                _this.catalogEntry.order_quantity = result.quantity;
            }
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/stock/catalog-entry/abstract-stock-catalog-entry.controller.js
// module id = 928
// module chunks = 0